import React, { Component } from 'react';
import {
	Col,
	Dropdown,
	DropdownMenu,
	DropdownToggle,
	DropdownItem,
	Card,
	CardBody,
	Button,
	Label,
	FormGroup,
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	Row,
	Input,
	CustomInput,
	Alert,
	Badge,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import S3 from 'react-aws-s3';
import Moment from 'moment';
import { taskArchivedUrl, taskChangeUrl, taskEditUrl, taskUrl } from '../../helpers/url';

const { SearchBar } = Search;

class Todo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			errorMsg: '',

			menu: false,
			task: [],
			editTask: {},
			editTaskIndex: '',
			deleteTask: {},
			deleteTaskIndex: '',
			id: 1,
			taskName: '',
			editTaskName: '',
			dueDate: '',
			editDueDate: '',
			eventDate: '',
			editEventDate: '',
			assigned: '',
			editAssigned: '',
			status: '0',
			editStatus: '0',
			priority: '0',
			editPriority: '0',
			category: '0',
			editCategory: '0',
			detailedInfo: '',
			editDetailedInfo: '',
			completedDate: '',
			taskSummary: '',

			fileUploading: false,
			fileSuccess: false,
			fileLocation: '',
			fileName: '',
            searchText: '',

			statuses: [
				{ id: 0, value: 'Not Defined' },
				{ id: 1, value: 'Not Started' },
				{ id: 2, value: 'In Progress' },
				{ id: 3, value: 'Pending/Awaiting Reply' },
				{ id: 4, value: 'In Review' },
				{ id: 5, value: 'Canceled' },
				{ id: 6, value: 'Completed' },
			],
			priorities: [
				{ id: 0, value: 'Not Defined' },
				{ id: 1, value: 'Low' },
				{ id: 2, value: 'Normal' },
				{ id: 3, value: 'Important' },
				{ id: 4, value: 'High' },
				{ id: 5, value: 'Top Priority' },
			],
			categories: [
				{ id: 0, value: 'Not Defined' },
				{ id: 1, value: 'General' },
				{ id: 2, value: 'Development' },
				{ id: 3, value: 'Testimony' },
				{ id: 4, value: 'Research' },
				{ id: 5, value: 'Media' },
				{ id: 6, value: 'Communication' },
				{ id: 7, value: 'Security' },
				{ id: 8, value: 'Conference/Training' },
				{ id: 9, value: '3D Design' },
				{ id: 10, value: 'Sattelite Imagery' },
				{ id: 11, value: 'Others' },
				{ id: 12, value: 'Economy' },
				{ id: 13, value: 'Meeting' },
				{ id: 14, value: 'Report' },
				{ id: 15, value: 'Digitalizing Book' },
				{ id: 16, value: 'Book' },
				{ id: 17, value: 'Translation' },
				{ id: 18, value: 'Digital Museum' },
				{ id: 19, value: 'Film Production' },
			],
			assignedPersons: [
				{ id: 0, value: 'Not Assigned' },
				{ id: 1, value: 'Adiljan' },
				{ id: 2, value: 'Afran' },
				{ id: 3, value: 'Bahtiyar' },
				{ id: 4, value: 'Erkin' },
				{ id: 5, value: 'Ilterish' },
				{ id: 6, value: 'Muetter' },
				{ id: 7, value: 'Uchkun' },
				{ id: 8, value: 'All' },
				{ id: 9, value: 'External' },
				{ id: 10, value: 'Dihumar' },
				{ id: 11, value: 'Hekmet' },
				{ id: 12, value: 'Martine' },
				{ id: 13, value: 'Abdushukur' },
				{ id: 14, value: 'Kawsar' },
				{ id: 15, value: 'Munire' },
				{ id: 16, value: 'Sabina' },
				{ id: 17, value: 'Shahnaz' },
				{ id: 18, value: 'Nigare' },
				{ id: 19, value: 'Mona' },
				{ id: 20, value: 'Kamran' },
				{ id: 21, value: 'Sidre' },
			],
		};

		this.addTask = this.addTask.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.editTask = this.editTask.bind(this);
		this.handleEditChange = this.handleEditChange.bind(this);
		this.saveTask = this.saveTask.bind(this);

		this.deleteTask = this.deleteTask.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);

		this.completeTask = this.completeTask.bind(this);
		this.handleCompleteChange = this.handleCompleteChange.bind(this);
		this.confirmComplete = this.confirmComplete.bind(this);
		this.archiveTask = this.archiveTask.bind(this);

		this.handleCancel = this.handleCancel.bind(this);
		this.showArchivedTasks = this.showArchivedTasks.bind(this);
		this.activeTasks = this.activeTasks.bind(this);

        this.handleSearchChange = this.handleSearchChange.bind(this);
	}

	componentDidMount() {
		this.activeTasks();
	}

    handleSearchChange(searchText) {
        this.setState({ searchText });
    }

	activeTasks() {
		const jwt = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = jwt.jwtToken;
		const URI = process.env.REACT_APP_API + 'task';

		fetch(URI, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', Authorization: accessToken },
		})
			.then(res => res.json())
			.then(data => {
				data.forEach(t => {
					t.dueDate =
						new Date(t.dueDate).getTime() < new Date().getTime()
							? [
									<Badge color="danger" className="mr-1">
										{t.dueDate}
									</Badge>,
							  ]
							: t.dueDate;
					t.status = this.state.statuses[t.status].value;
					t.category = this.state.categories[t.category].value;
					t.priority = this.state.priorities[t.priority].value;
					t.action = [
						<Link task-id={t.id} onClick={this.editTask}>
							Edit
						</Link>,
						' | ',
						<Link task-id={t.id} onClick={this.deleteTask}>
							Delete
						</Link>,
					];
				});

				this.setState({
					task: data,
				});
			})
			.catch(err => {
				this.setState({
					loading: false,
					error: true,
					errorMsg: err.message,
				});
			});
	}

	addImage = async event => {
		let mid = event.currentTarget.getAttribute('data-mid');

		this.setState({
			fileUploading: true,
		});
		Moment.locale('en');
		let dt = new Date();
		let date = Moment(dt).format('YYYY-MM-DD');
		let file = event.target.files[0];
		let keyName = 'tasks/' + mid + '/files/' + date + '/' + file.name;

		this.setState({
			fileName: file.name,
		});

		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);

		await ReactS3Client.uploadFile(file, keyName)
			.then(data => {
				this.setState({
					fileLocation: data.location,
					fileSuccess: true,
					fileUploading: false,
				});
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: 'Failed: ' + err,
				});
			});
		event.preventDefault();
	};

	/*-----------------------------------------------------------------ADDING TASK--------------------------------------------------------------------*/

	addTask(event) {
		var unixTimestampDue = new Date(this.state.dueDate).getTime() / 1000;
		var unixTimestampEvent = new Date(this.state.eventDate).getTime() / 1000;
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
		fetch(taskUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Authorization: accessToken },
			body: JSON.stringify({
				id: 0,
				taskName: this.state.taskName,
				dueDate: unixTimestampDue,
				eventDate: unixTimestampEvent,
				assigned: this.state.assigned,
				status: this.state.status,
				priority: this.state.priority,
				category: this.state.category,
				detailedInfo: this.state.detailedInfo,
				userId: userId,
			}),
		})
			.then(res => res.json())
			.then(response => {
				if (response > 0) {
					const fStatus = this.state.statuses.find(obj => {
						return obj.id == this.state.status;
					});
					const fPriority = this.state.priorities.find(obj => {
						return obj.id == this.state.priority;
					});
					const fCategory = this.state.categories.find(obj => {
						return obj.id == this.state.category;
					});
					const newTask = {
						id: response,
						taskName: this.state.taskName,
						dueDate: this.state.dueDate,
						eventDate: this.state.eventDate,
						assigned: this.state.assigned,
						status: fStatus.value,
						priority: fPriority.value,
						category: fCategory.value,
						detailedInfo: this.state.detailedInfo,
						action: [
							<Link task-id={response} onClick={this.editTask}>
								Edit
							</Link>,
							' | ',
							<Link task-id={response} onClick={this.deleteTask}>
								Delete
							</Link>,
						],
					};

					this.setState(prevState => ({
						task: [...prevState.task, newTask],
						addModal: false,
						editModal: false,
						deleteModal: false,
						completeModal: false,
					}));
				}
			})
			.catch(error => {
				console.log(error, 'error');
			});
		event.preventDefault();
	}

	handleChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	/*-----------------------------------------------------------------EDITING TASK--------------------------------------------------------------------*/

	editTask(event) {
		let taskId = event.currentTarget.getAttribute('task-id');
		this.setState({ editModal: !this.state.modal });
		for (let [i, data] of this.state.task.entries()) {
			if (data.id == taskId) {
				this.setState({
					editTask: data,
					editTaskIndex: i,
					id: data.id,
					editTaskName: data.taskName,
					editDueDate: data.dueDate,
					editEventDate: data.eventDate,
					editAssigned: data.assigned,
					editStatus: data.status,
					editPriority: data.priority,
					editCategory: data.category,
					editDetailedInfo: data.detailedInfo,
				});
			}
		}
	}

	handleEditChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	saveTask(event) {
		var unixTimestampDue = this.state.editDueDate != null ? new Date(this.state.editDueDate).getTime() / 1000 : null;
		var unixTimestampEvent = this.state.editEventDate != null ? new Date(this.state.editEventDate).getTime() / 1000 : null;

		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;

		const fStatus = this.state.statuses.find(obj => {
			return obj.value === this.state.editStatus;
		});
		const fPriority = this.state.priorities.find(obj => {
			return obj.value === this.state.editPriority;
		});
		const fCategory = this.state.categories.find(obj => {
			return obj.value === this.state.editCategory;
		});

		const accessToken = session.jwtToken;

		fetch(taskEditUrl, {
			// put endpoint here
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Authorization: accessToken },
			body: JSON.stringify({
				id: this.state.id,
				taskName: this.state.editTaskName,
				dueDate: unixTimestampDue,
				eventDate: unixTimestampEvent,
				assigned: this.state.editAssigned,
				status: fStatus.id,
				priority: fPriority.id,
				category: fCategory.id,
				detailedInfo: this.state.editDetailedInfo,
				userId: userId,
			}),
		})
			.then(res => res.json())
			.then(response => {
				if (response > 0) {
					this.setState(prevState => {
						const updatedTasks = [...prevState.task];
						updatedTasks[prevState.editTaskIndex] = {
							id: prevState.id,
							taskName: prevState.editTaskName,
							dueDate: prevState.editDueDate,
							eventDate: prevState.editEventDate,
							assigned: prevState.editAssigned,
							status: prevState.editStatus,
							priority: prevState.editPriority,
							category: prevState.editCategory,
							detailedInfo: prevState.editDetailedInfo,
							action: [
								<Link task-id={prevState.id} onClick={this.editTask}>
									Edit
								</Link>,
								' | ',
								<Link task-id={prevState.id} onClick={this.deleteTask}>
									Delete
								</Link>,
							],
						};
						return { task: updatedTasks, editModal: false };
					});
				}
			})
			.catch(error => {
				console.log(error, 'error while editing the task');
			});
		event.preventDefault();
	}

	/*-----------------------------------------------------------------DELETING TASK--------------------------------------------------------------------*/

	deleteTask(event) {
		let taskId = event.currentTarget.getAttribute('task-id');
		this.setState({ deleteModal: !this.state.modal });
		for (let [i, data] of this.state.task.entries()) {
			if (data.id == taskId) {
				this.setState({ deleteTask: data, deleteTaskIndex: i });
			}
		}
	}

	confirmDelete(event) {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
		if (Object.keys(this.state.deleteTask).length > 0) {
			fetch(taskChangeUrl, {
				// put endpoint here
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Authorization: accessToken },
				body: JSON.stringify({
					id: this.state.deleteTask.id,
					action: 'remove',
				}),
			})
				.then(res => res.json())
				.then(response => {
					if (response > 0) {
						this.setState(prevState => {
							const updatedTasks = [...prevState.task];
							updatedTasks.splice(prevState.deleteTaskIndex, 1);
							return { task: updatedTasks, deleteTask: {}, deleteTaskIndex: '', deleteModal: false };
						});
					}
				})
				.catch(error => {
					console.log(error, 'error while removing the task');
				});
		}
		event.preventDefault();
	}

	/*-----------------------------------------------------------------COMPLETING TASK--------------------------------------------------------------------*/

	completeTask(event) {
		this.setState({ completeModal: !this.state.modal });
		let taskId = event.currentTarget.getAttribute('task-id');
		for (let [i, data] of this.state.task.entries()) {
			if (data.id == taskId) {
				this.setState({
					completeTask: data,
					completeTaskIndex: i,
					id: data.id,
					completeTaskName: data.taskName,
					completeDueDate: data.dueDate,
					completeEventDate: data.eventDate,
					completeAssigned: data.assigned,
					completeStatus: data.status,
					completePriority: data.priority,
					completeCategory: data.category,
					completeDetailedInfo: data.detailedInfo,
				});
			}
		}
	}

	handleCompleteChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	confirmComplete(event) {
		if (this.state.id > 0) {
			const session = JSON.parse(sessionStorage.getItem('authUser'));
			const accessToken = session.jwtToken;
			var unixTimestampComplete = new Date(this.state.completedDate).getTime() / 1000;
			fetch(taskChangeUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Authorization: accessToken },
				body: JSON.stringify({
					id: this.state.id,
					completedDate: unixTimestampComplete,
					taskSummary: this.state.taskSummary,
					action: 'complete',
				}),
			})
				.then(res => res.json())
				.then(response => {
					if (response > 0) {
						this.setState({ completeModal: false });
					}
				})
				.catch(error => {
					console.log(error, 'error while completing the task');
				});
		}
		event.preventDefault();
	}

	showArchivedTasks(event) {
		this.setState({
			task: [],
		});
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
		fetch(taskArchivedUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', Authorization: accessToken },
		})
			.then(res => res.json())
			.then(response => {
				const archivedTasks = response.map(data => ({
					id: data.id,
					taskName: data.taskName,
					dueDate: data.dueDate,
					eventDate: data.eventDate,
					assigned: data.assigned,
					status: data.taskSummary,
					priority: '-',
					category: '-',
					detailedInfo: data.detailedInfo,
					action: '-',
				}));
				this.setState({ task: archivedTasks });
			})
			.catch(error => {
				console.log(error, 'error while retrieving archived task list');
			});
	}

	archiveTask(event) {
		let archiveTaskIndx = 0;
		let taskId = event.currentTarget.getAttribute('task-id');
		for (let [i, data] of this.state.task.entries()) {
			if (data.id == taskId) {
				archiveTaskIndx = i;
			}
		}
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
		if (taskId > 0) {
			fetch(taskChangeUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Authorization: accessToken },
				body: JSON.stringify({
					id: taskId,
					action: 'archive',
				}),
			})
				.then(res => res.json())
				.then(response => {
					if (response > 0) {
						this.state.task.splice(archiveTaskIndx, 1);
					}
				})
				.catch(error => {
					console.log(error, 'error while archiving the task');
				});
		}
		event.preventDefault();
	}

	/*-----------------------------------------------------------------CANCEL BUTTON--------------------------------------------------------------------*/

	handleCancel(event) {
		event.preventDefault();
		this.setState({ addModal: false, editModal: false, deleteModal: false, completeModal: false });
	}

	render() {
		const data = {
			columns: [
				{
					dataField: 'id',
					text: 'No.',
					sort: true,
				},
				{
					dataField: 'taskName',
					text: 'Task Name',
				},
				{
					dataField: 'dueDate',
					text: 'Due Date',
					sort: true,
				},
				{
					dataField: 'assigned',
					text: 'Assigned To',
					sort: true,
				},
				{
					dataField: 'status',
					text: 'Status',
					sort: true,
				},
				{
					dataField: 'priority',
					text: 'Priority',
					sort: true,
				},
				{
					dataField: 'category',
					text: 'Category',
				},
				{
					dataField: 'action',
					text: 'Action',
				},
			],

			rows: this.state.task,
		};

		const options = {
			// pageStartIndex: 0,
			hideSizePerPage: false,
			hidePageListOnlyOnePage: false,
			sizePerPageList: [
				{
					text: '5th',
					value: 5,
				},
				{
					text: '10th',
					value: 10,
				},
				{
					text: 'All',
					value: data.rows.length,
				},
			],
		};

		const selectRow = {
			mode: 'checkbox',
			clickToSelect: true,
		};

		const expandRow = {
			renderer: row => (
				<>
					<FormGroup className="mb-2">
						<Label htmlFor="billing-address">Detailed Information</Label>
						<p>{row.detailedInfo}</p>
					</FormGroup>
					<CustomInput type="file" data-mid={row.id} id="customFile" onChange={this.addImage} />
					{this.state.fileUploading ? (
						<div role="status" class="me-2 spinner-border text-info">
							<span class="sr-only">Loading...</span>
						</div>
					) : (
						''
					)}
					<Alert color="success" isOpen={this.state.fileSuccess}></Alert>
					<hr />

					{row.status === 'Completed' ? (
						<FormGroup className="mb-2">
							<Label htmlFor="billing-address">Summary of completed task:</Label>
							<p>{row.taskSummary}</p>
						</FormGroup>
					) : (
						''
					)}

					<Button task-id={row.id} onClick={this.completeTask} type={'submit'} hidden={row.status === 'Completed'} color={'success'}>
						Completed
					</Button>

					<Button task-id={row.id} onClick={this.archiveTask} type={'submit'} color={'warning'}>
						Archive
					</Button>
				</>
			),
			showExpandColumn: true,
			expandByColumnOnly: true,
		};

		return (
			<React.Fragment>
				<Col lg={12}>
					<Card>
						<CardBody>
							<Dropdown isOpen={this.state.menu} toggle={() => this.setState({ menu: !this.state.menu })} className="float-right">
								<DropdownToggle tag="i" className="arrow-none card-drop">
									<i className="mdi mdi-dots-vertical"></i>
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem onClick={this.activeTasks}>Active Tasks</DropdownItem>

									<DropdownItem>Not Assigned Tasks</DropdownItem>

									<DropdownItem onClick={this.showArchivedTasks}>Archived Tasks</DropdownItem>
								</DropdownMenu>
							</Dropdown>

							<div>
								<Link onClick={() => this.setState({ addModal: !this.state.modal })} className="popup-form btn btn-primary">
									Add New Task
								</Link>
							</div>
							<div>
								<Alert id="error" color="error" isOpen={this.state.error} toggle={this.responseHandling}>
									{this.state.errorMsg}
								</Alert>
							</div>
							<Modal
								size="xl"
								isOpen={this.state.addModal}
								centered={true}
								toggle={() => this.setState({ addModal: !this.state.addModal })}>
								<ModalHeader toggle={() => this.setState({ addModal: !this.state.addModal })}>Form</ModalHeader>

								<ModalBody>
									<Form autoComplete="off">
										<Row>
											<Col lg={12}>
												<FormGroup>
													<Label htmlFor="taskName">Task Name</Label>
													<Input
														onChange={this.handleChange}
														name="taskName"
														type="text"
														className="form-control"
														id="taskName"
														placeholder="Enter Task Name"
													/>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col lg={3}>
												<FormGroup>
													<Label htmlFor="eventDate">Event Date</Label>
													<Input onChange={this.handleChange} name="eventDate" type="date" className="form-control" id="eventDate" />
												</FormGroup>
											</Col>
											<Col lg={3}>
												<FormGroup>
													<Label htmlFor="dueDate">Due Date</Label>
													<Input onChange={this.handleChange} name="dueDate" type="date" className="form-control" id="dueDate" />
												</FormGroup>
											</Col>

											<Col>
												<FormGroup>
													<Label htmlFor="assigned">Assigned To</Label>
													<select
														className="form-control select2"
														name="assigned"
														value={this.state.assigned}
														defaultValue={'Not Defined'}
														onChange={this.handleChange}>
														{this.state.assignedPersons.map((data, id) => (
															<option key={id} value={data.value}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="status">Status</Label>
													<select className="form-control select2" name="status" onChange={this.handleChange}>
														{this.state.statuses
															.filter(data => data.id < 6)
															.map((data, id) => (
																<option key={id} value={data.id}>
																	{data.value}
																</option>
															))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="priority">Priority</Label>
													<select
														className="form-control select2"
														name="priority"
														value={this.state.priority}
														defaultValue={'1'}
														onChange={this.handleChange}>
														{this.state.priorities.map((data, id) => (
															<option key={id} value={data.id}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="category">Category</Label>
													<select
														className="form-control select2"
														name="category"
														value={this.state.category}
														defaultValue={'1'}
														onChange={this.handleChange}>
														{this.state.categories.map((data, id) => (
															<option key={id} value={data.id}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col lg={12}>
												<FormGroup>
													<Label htmlFor="detailedInfo">Detailed Information</Label>
													<textarea
														onChange={this.handleChange}
														name="detailedInfo"
														className="form-control"
														id="detailedInfo"
														rows="3"></textarea>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col lg={12}>
												<div className="text-right">
													<Button type="submit" color="primary" onClick={this.addTask}>
														Create Task
													</Button>
													&nbsp;
													<Button color="light" onClick={this.handleCancel}>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</ModalBody>
							</Modal>

							<Modal
								size="xl"
								isOpen={this.state.editModal}
								centered={true}
								toggle={() => this.setState({ editModal: !this.state.editModal })}>
								<ModalHeader toggle={() => this.setState({ editModal: !this.state.editModal })}>Edit Task</ModalHeader>

								<ModalBody>
									<Form autoComplete="off">
										<Row>
											<Col lg={12}>
												<FormGroup>
													<Label htmlFor="taskName">Task Name</Label>
													<Input
														value={this.state.editTaskName}
														onChange={this.handleEditChange}
														name="editTaskName"
														type="text"
														className="form-control"
														id="taskName"
														placeholder="Enter Task Name"
													/>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col lg={3}>
												<FormGroup>
													<Label htmlFor="eventDate">Event Date</Label>
													<Input
														onChange={this.handleEditChange}
														value={this.state.editEventDate}
														name="editEventDate"
														type="date"
														className="form-control"
														id="eventDate"
													/>
												</FormGroup>
											</Col>
											<Col lg={3}>
												<FormGroup>
													<Label htmlFor="dueDate">Due Date</Label>
													<Input
														value={this.state.editDueDate}
														onChange={this.handleEditChange}
														name="editDueDate"
														type="date"
														className="form-control"
														id="dueDate"
													/>
												</FormGroup>
											</Col>

											<Col>
												<FormGroup>
													<Label htmlFor="assigned">Assigned To</Label>
													<select
														className="form-control select2"
														name="editAssigned"
														value={this.state.editAssigned}
														defaultValue={'1'}
														onChange={this.handleEditChange}>
														{this.state.assignedPersons.map((data, id) => (
															<option key={id} value={data.value}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="status">Status</Label>
													<select
														className="form-control select2"
														name="editStatus"
														value={this.state.editStatus}
														defaultValue={'1'}
														onChange={this.handleEditChange}>
														{this.state.statuses
															.filter(data => data.id < 6)
															.map((data, id) => (
																<option key={id} value={data.value}>
																	{data.value}
																</option>
															))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="priority">Priority</Label>
													<select
														className="form-control select2"
														name="editPriority"
														value={this.state.editPriority}
														defaultValue={'1'}
														onChange={this.handleEditChange}>
														{this.state.priorities.map((data, id) => (
															<option key={id} value={data.value}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
											<Col>
												<FormGroup>
													<Label htmlFor="category">Category</Label>
													<select
														className="form-control select2"
														name="editCategory"
														value={this.state.editCategory}
														defaultValue={'1'}
														onChange={this.handleEditChange}>
														{this.state.categories.map((data, id) => (
															<option key={id} value={data.value}>
																{data.value}
															</option>
														))}
													</select>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col lg={12}>
												<FormGroup>
													<Label htmlFor="detailedInfo">Detailed Information</Label>
													<textarea
														onChange={this.handleEditChange}
														value={this.state.editDetailedInfo}
														name="editDetailedInfo"
														className="form-control"
														id="detailedInfo"
														rows="3"></textarea>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col lg={12}>
												<div className="text-right">
													<Button type="submit" color="primary" onClick={this.saveTask}>
														Save Changes
													</Button>
													&nbsp;
													<Button color="light" onClick={this.handleCancel}>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</ModalBody>
							</Modal>

							<Modal
								size="m"
								isOpen={this.state.deleteModal}
								centered={true}
								toggle={() => this.setState({ deleteModal: !this.state.deleteModal })}>
								<ModalHeader toggle={() => this.setState({ deleteModal: !this.state.deleteModal })}>Deleting Task!</ModalHeader>

								<ModalBody>
									<Form autoComplete="off">
										<Row>
											<Col lg={12}>
												<FormGroup>
													<p>Do you really want to delete following task?</p>
													<p>Task Name: {this.state.deleteTask.taskName}</p>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col>
												<div className="text-right">
													<Button type="submit" color="danger" onClick={this.confirmDelete}>
														Delete Task
													</Button>
													&nbsp;
													<Button color="light" onClick={this.handleCancel}>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</ModalBody>
							</Modal>

							<Modal
								size="m"
								isOpen={this.state.completeModal}
								centered={true}
								toggle={() => this.setState({ completeModal: !this.state.completeModal })}>
								<ModalHeader toggle={() => this.setState({ completeModal: !this.state.completeModal })}>Completing Task!</ModalHeader>

								<ModalBody>
									<Form autoComplete="off">
										<Row>
											<Col lg={6}>
												<FormGroup>
													<Label htmlFor="dueDate">Completed Date</Label>
													<Input
														onChange={this.handleCompleteChange}
														name="completedDate"
														type="date"
														className="form-control"
														id="completedDate"
													/>
												</FormGroup>
											</Col>
											<Col lg={12}>
												<FormGroup>
													<Label htmlFor="taskSummary">Task Summary</Label>
													<textarea
														onChange={this.handleCompleteChange}
														name="taskSummary"
														className="form-control"
														id="taskSummary"
														rows="3"></textarea>
												</FormGroup>
											</Col>
										</Row>

										<Row>
											<Col>
												<div className="text-right">
													<Button type="submit" color="success" onClick={this.confirmComplete}>
														Task Completed
													</Button>
													&nbsp;
													<Button color="light" onClick={this.handleCancel}>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								</ModalBody>
							</Modal>

							<ToolkitProvider keyField="id" data={this.state.task} columns={data.columns} search>
                                {props => (
                                    <div>
                                        <SearchBar
                                            {...props.searchProps}
                                            value={this.state.searchText} // Add this line
                                            onChange={this.handleSearchChange} // Add this line
                                        />
                                        <hr />
                                        <BootstrapTable
                                            striped
                                            hover
                                            {...props.baseProps}
                                            expandRow={expandRow}
                                            pagination={paginationFactory(options)}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
						</CardBody>
					</Card>
				</Col>
			</React.Fragment>
		);
	}
}

export default Todo;
